import React from 'react'
import { router, useLocalSearchParams } from 'expo-router'
import { Alert } from 'react-native'

import type { Id } from '@ppwr/convex/_generated/dataModel'
import { useStore } from '@/models'
import { GameContainer } from '@/screens/GameContainer/GameContainer'

export default function ConvexGameScreen() {
  // Spectator state used to live in URL params (`spectating=true&tournamentId=…`)
  // pushed by the tournament Tables tab. It now lives on the server in
  // `game.observerUserIds` and is queried via `getMySpectatorStatus`, so the
  // route only needs the gameId and the optional pending-join hand-off.
  const { gameId, pendingJoin, code } = useLocalSearchParams<{
    gameId: string
    pendingJoin?: string
    code?: string
  }>()
  const { user } = useStore().session

  const userId = user?.auth0Id || 'guest'

  if (!gameId) {
    Alert.alert('Game Not Found', 'Unable to find the game.', [
      {
        text: 'Go Home',
        onPress: () => router.replace('/(root)/(tabs)/play')
      }
    ])
    return null
  }

  return (
    <GameContainer
      gameId={gameId as Id<'games'>}
      userId={userId}
      pendingJoin={pendingJoin === 'true'}
      joinCode={code}
    />
  )
}
